import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["installments", "select", "options", "submit", "spinner", "label", "summary"]
  static values = { previewUrl: String }

  connect() {
    this.idleLabel = this.labelTarget.textContent
    this.restore = (event) => { if (event.persisted) this.reset() }
    window.addEventListener("pageshow", this.restore)
    this.refresh()
  }

  disconnect() {
    window.removeEventListener("pageshow", this.restore)
  }

  refresh() {
    const plan = this.element.querySelector("input[name='checkout[plan_years]']:checked")
    const card = this.element.querySelector("input[name='checkout[billing_type]']:checked")?.value === "CREDIT_CARD"
    const visible = card && Number(plan?.dataset.maxInstallments) > 1

    this.installmentsTarget.hidden = !visible
    this.selectTarget.disabled = !visible
    if (plan) this.showOptionsFor(plan.value)
    this.preview()
  }

  preview() {
    if (!this.hasSummaryTarget || !this.previewUrlValue) return

    const params = new URLSearchParams()
    for (const [name, value] of new FormData(this.element)) {
      if (name.startsWith("checkout[")) params.append(name, value)
    }
    const url = `${this.previewUrlValue}?${params}`
    if (this.summaryTarget.getAttribute("src") !== url) this.summaryTarget.src = url
  }

  submit() {
    this.submitTarget.disabled = true
    this.element.setAttribute("aria-busy", "true")
    this.spinnerTarget.toggleAttribute("hidden", false)
    this.labelTarget.textContent = "Gerando sua cobrança…"
  }

  reset() {
    this.submitTarget.disabled = false
    this.element.removeAttribute("aria-busy")
    this.spinnerTarget.toggleAttribute("hidden", true)
    this.labelTarget.textContent = this.idleLabel
  }

  showOptionsFor(years) {
    if (this.selectTarget.dataset.plan === years) return

    const chosen = this.selectTarget.value
    const template = this.optionsTargets.find((option) => option.dataset.plan === years)
    this.selectTarget.replaceChildren(template.content.cloneNode(true))
    this.selectTarget.value = [...this.selectTarget.options].some((option) => option.value === chosen) ? chosen : "1"
    this.selectTarget.dataset.plan = years
  }
}
